import { Undefinable, Emptyable, PaymentMethod, CampaignAction, CommandFormEmbedVersion } from "@simplyk/common";
import { inferRouterOutputs } from "@trpc/server";
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormHandleSubmit,
  UseFormSetValue,
  UseFormTrigger,
} from "react-hook-form";

import { AppRouterType } from "../../../common/helpers/trpc";
import { DonationFormPaymentInput } from "../../../common/types/donationForm";

import { ScreenSize } from "@/common/hooks/useScreenSize";
import { TicketingPaymentInput } from "@/common/types/ticketing";
import { DiscountOutput, DonationFormFrontendPageOutput, TicketingFrontendPageOutput } from "@/common/types/trpc";

type SubmitCommandOutput = NonNullable<inferRouterOutputs<AppRouterType>["form_submitCommand"]>["data"];

export interface PaymentSucceeded {
  data: SubmitCommandOutput;
  paymentInput: DonationFormPaymentInput | TicketingPaymentInput;
  onSuccess?: (() => Promise<void>) | undefined;
}

export type Event = {
  title: string;
  address: string;
  startTime: number | undefined;
  endTime: number | undefined;
};

export interface AmplitudeContext extends Record<string, unknown> {
  paymentMethod: Undefinable<PaymentMethod>;
  isMobile: boolean;
  isEmbed: boolean;
  formEmbedVersion: CommandFormEmbedVersion | null;
  screenSize: ScreenSize;
  hasReceiptMessage?: boolean | undefined;
  hasNoSuggestedAmount?: boolean | undefined;
  hasTaxes?: boolean;
  is_sweepstakes?: boolean;
}

export type SaveDonationOrOrderObject = PaymentSucceeded | PaymentFailed;

export interface PaymentFailed {
  error: { message: string; code: string; declineCode?: string };
}

export interface CreatedCampaigns {
  id: string;
  teamId?: string;
  color: string;
  logoUrl?: string;
  campaignAction: CampaignAction;
  multipleCampaigns: boolean;
  isFundraiserFormEditDisabled: boolean;
  token: string;
}

export const isPaymentFailed = (result: SaveDonationOrOrderObject): result is PaymentFailed => {
  return Boolean((result as PaymentFailed).error);
};

export type PaymentElementProps<T extends FieldValues> = {
  handleSubmit: UseFormHandleSubmit<TicketingPaymentInput | DonationFormPaymentInput>;
  formObject: DonationFormFrontendPageOutput | TicketingFrontendPageOutput;
  setValue: UseFormSetValue<DonationFormPaymentInput | TicketingPaymentInput>;
  trigger: UseFormTrigger<T>;
  control: Control<T>;
  formStateErrors: FieldErrors<T>;
  validDiscount?: Emptyable<DiscountOutput>;
  billingDetails?: React.ReactNode;
  shouldDisplaySubmitButton?: boolean;
};

export interface CustomRedirect {
  url: string;
  queryParams?: Record<string, unknown>;
}
